export default __webpack_public_path__ + "static/media/couture-model.e4d33acc.png";